export enum OrderType { 
    DESC = 'DESC',
    ASC = 'ASC'
}